module.exports = __webpack_public_path__ + "img/logo-360x120.ba04ec57.png";